import angular from 'angular';
import adminCreateSectionComponent from './adminCreateSection.component';

let adminCreateSectionModule = angular.module('adminCreateSection', []).component('adminCreateSection', adminCreateSectionComponent);

export default adminCreateSectionModule;



// WEBPACK FOOTER //
// ./app/components/adminCreateSection/adminCreateSection.js